// Import of the module

import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type ApiKey = {
  id: number;
  user_id?: number | null;
  user_email?: string | null;
  application_name?: string | null;
  access_token?: string | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns

export const api_keys_columns: ColumnDef<ApiKey>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "user_email",
    header: "User",
    cell: ({ row }) => {
      const value = row.getValue("user_email");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "application_name",
    header: "Application Name",
    cell: ({ row }) => {
      const value = row.getValue("application_name");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "access_token",
    header: "Access Token",
    cell: ({ row }) => {
      const value = row.getValue("access_token");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
